/**
 * @generated SignedSource<<071888d7721f0c89259ab5d475627f62>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type reminderElementForm_ReminderElementFragment$data = {
  readonly id: string;
  readonly text: string;
  readonly title: string;
  readonly " $fragmentType": "reminderElementForm_ReminderElementFragment";
};
export type reminderElementForm_ReminderElementFragment$key = {
  readonly " $data"?: reminderElementForm_ReminderElementFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"reminderElementForm_ReminderElementFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "reminderElementForm_ReminderElementFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "text",
      "storageKey": null
    }
  ],
  "type": "ReminderElement",
  "abstractKey": null
};

(node as any).hash = "31e788d9a8dc2678b7cb0259f5cd30d8";

export default node;
